<template>
  <div>
    <vg-field
        v-bind="$attrs"
        v-on="$listeners"
        :label="label"
        :value="this.timeFormat(dateOfValue)"
        :placeholder="`请选择${label}`"
        readonly
        is-link
        @click="onClick"
    />
    <van-popup :value="show" position="bottom" class="vantPopup" @input="onCancel">
      <van-datetime-picker type="datetime" title="选择完整时间" :min-date="minDate" :filter="onFilter"
                           @confirm="onConfirm" @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>

import {DatetimePicker, Popup, Toast} from "vant";
import {mapState} from "pinia";
import useDpApplicationConstructionTime from "@/store/dp-application-construction-time-store";
import VgField from "@/components/Commons/VgField.vue";
import datetimeHoursMinutes from "@/filters/datetime-hours-minutes";

export default {
  name: "DpApplicationConstructionTimeField",
  components: {
    VgField,
    "van-datetime-picker": DatetimePicker,
    "van-popup": Popup
  },
  props: {
    label: String,
    value: null,
    disabled: Boolean,
    end: Boolean
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapState(useDpApplicationConstructionTime, ['startTime', 'endTime', 'limitedDuration']),
    minDate() {
      if (!this.startTime || !this.end) {
        const current = new Date();
        current.setHours(current.getHours() + 1)
        current.setMinutes(0)
        return current
      }
      const nextStartTime = new Date(this.startTime)
      nextStartTime.setHours(nextStartTime.getHours() + 1)
      return nextStartTime > new Date() ? nextStartTime : new Date()
    },
    dateOfValue() {
      return this.value && new Date(this.value)
    }
  },
  watch: {
    startTime(newValue) {
      if (!this.value) {
        return this.value
      }
      if (this.end) {
        let endTime = new Date(this.endTime)
        let endTimeStamp = endTime.getTime();
        let startTimeStamp = newValue.getTime();
        if (endTimeStamp <= startTimeStamp) {
          this.input(null)
        }
      }
    },
    endTime(newValue) {
      if (!this.value) {
        return
      }
      if (!this.end) {
        let startTime = new Date(this.startTime)
        let startTimeStamp = startTime.getTime();
        let endTimeStamp = newValue.getTime();
        if (endTimeStamp <= startTimeStamp) {
          this.input(null)
        }
      }
    }
  },
  methods: {
    onClick() {
      this.show = true;
    },
    input(value) {
      this.$emit('input', value?.toISOString())
    },
    onConfirm(value) {
      if (!this.end) {
        this.onStartTimeConfirm(value)
      } else {
        this.onEndTimeConfirm(value)
      }
    },
    //开始时间下拉框确认
    onStartTimeConfirm(value) {
      console.log("开始时间下拉框确认")
      console.log(value)
      // let endTime = new Date(this.endTime)
      // let endTimeStamp = endTime.getTime();
      // let startTimeStamp = value.getTime();
      // if (endTimeStamp === startTimeStamp) {
      //   return Toast('施工开始时间不能等于施工开始时间！');
      // } else if (endTimeStamp < startTimeStamp) {
      //   return Toast('施工开始时间不能小于施工开始时间！');
      // }
      let minTime = new Date(this.startTime)
      minTime.setDate(minTime.getDate() - this.limitedDuration)
      let minTimeStamp = minTime.getTime();
      let startTimeStamp = value.getTime();
      if (startTimeStamp <= minTimeStamp) {
          Toast({
              duration: 6000,
              message: '施工开始时间不得早于' + datetimeHoursMinutes(minTime)
          });
        //this.$toast('施工开始时间不得早于' + datetimeHoursMinutes(minTime), { duration:8000 })
        return
      }
      useDpApplicationConstructionTime().setStartTime(value)
      console.log(this.startTimeValue)
      this.input(value);
      this.show = false;
    },
    timeFormat(time) { // 时间格式化 2019-09-08 00:00
      if (!time) return ''
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = time.getDate();
      day = day < 10 ? '0' + day : day;
      let hour = time.getHours();
      hour = hour < 10 ? '0' + hour : hour;
      let minute = time.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute
    },
    //结束时间下拉框确认
    onEndTimeConfirm(value) {
      console.log("结束时间下拉框确认")
      console.log(value)
      if (!this.startTime) {
        Toast('请先选择施工开始时间！');
        this.show = false;
        return;
      }
      if (this.limitedDuration) {
        let maxTime = new Date(this.startTime)
        maxTime.setDate(maxTime.getDate() + this.limitedDuration)
        let maxTimeStamp = maxTime.getTime();
        let endTimeStamp = value.getTime();
        if (endTimeStamp >= maxTimeStamp) {
          Toast({
              duration: 6000,
              message: '施工结束时间不得晚于' + datetimeHoursMinutes(maxTime)
          });
          //this.$toast('施工结束时间不得晚于' + datetimeHoursMinutes(maxTime), { duration:8000 })
          return
        }
      }
      useDpApplicationConstructionTime().setEndTime(value)
      console.log(this.endTimeValue)
      this.input(value);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onFilter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option == 0);
      }
      return options;
    },
  }
}
</script>

<style scoped>

</style>